import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "d-flex gap-2 app-yes-no",
  role: "radiogroup"
}
const _hoisted_2 = ["disabled", "id", "aria-checked", "onClick"]


export default /*@__PURE__*/_defineComponent({
  __name: 'AppYesNo',
  props: {
    modelValue: { type: [Boolean, null], default: null },
    disabled: { type: Boolean, default: false },
    idPrefix: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;
const options = [
  { value: true, label: "Sim" },
  { value: false, label: "Não" },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (opt) => {
      return _createElementVNode("button", {
        key: String(opt.value),
        type: "button",
        class: _normalizeClass(["app-yes-no-pill text-action", { selected: __props.modelValue === opt.value }]),
        disabled: __props.disabled,
        id: __props.idPrefix ? `${__props.idPrefix}-${opt.value ? 'sim' : 'nao'}` : undefined,
        role: "radio",
        "aria-checked": __props.modelValue === opt.value,
        onClick: ($event: any) => (emit('update:modelValue', opt.value))
      }, _toDisplayString(opt.label), 11, _hoisted_2)
    }), 64))
  ]))
}
}

})